/* Embudo de la tienda: cuenta visitas únicas que llegan a cada paso (carrito, ventana de pagos,
   formulario de contraentrega) y las envía a la app de administración. No envía datos personales.
   Requiere window.kaliFunnel = { api } (lo define snippets/kali-funnel.liquid). */
(function () {
  'use strict';

  var cfg = window.kaliFunnel;
  if (!cfg || !cfg.api) return;
  var endpoint = String(cfg.api).replace(/\/+$/, '') + '/api/embudo/evento';

  function store(fn) { try { return fn(window.sessionStorage); } catch (e) { return null; } }

  // Id anónimo de la visita: vive solo en esta pestaña.
  var visitId = store(function (s) { return s.getItem('kfn:vid'); });
  if (!visitId) {
    visitId = (Math.random().toString(36).slice(2) + Date.now().toString(36)).slice(0, 24);
    store(function (s) { s.setItem('kfn:vid', visitId); });
  }
  var device = window.matchMedia && window.matchMedia('(max-width: 767px)').matches ? 'mobile' : 'desktop';

  /* step: 'cart' | 'pay_panel' | 'cod_form' | 'addi_click' | 'sistecredito_click'. Cada paso+producto se envía una sola vez por visita. */
  function track(step, product) {
    product = String(product || '').replace(/\s+/g, ' ').trim().slice(0, 120);
    if (!step || !product) return;
    var key = 'kfn:' + step + ':' + product;
    if (store(function (s) { return s.getItem(key); })) return;
    store(function (s) { s.setItem(key, '1'); });
    try {
      fetch(endpoint, {
        method: 'POST', keepalive: true,
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ visitId: visitId, step: step, product: product, device: device })
      }).catch(function () { /* sin conexión: se pierde este conteo, nada más */ });
    } catch (e) { /* ignorar */ }
  }

  window.kaliFunnel.track = track;
})();
